module.exports = __webpack_public_path__ + "img/7.c39c85a1.png";